import { Phase } from '../types';

export class GameState {
  private _phase: Phase;

  constructor() {
    this._phase = Phase.MENU;
  }

  get phase(): Phase {
    return this._phase;
  }

  startGame(): void {
    this._phase = Phase.PLAYING;
  }

  victory(): void {
    if (this._phase === Phase.PLAYING) {
      this._phase = Phase.VICTORY;
    }
  }

  defeat(): void {
    if (this._phase === Phase.PLAYING) {
      this._phase = Phase.DEFEAT;
    }
  }

  reset(): void {
    this._phase = Phase.MENU;
  }

  get isPlaying(): boolean {
    return this._phase === Phase.PLAYING;
  }

  get isGameOver(): boolean {
    return this._phase === Phase.VICTORY || this._phase === Phase.DEFEAT;
  }
}
